import { useTranslation } from "@/hooks/useTranslation";
import { useRouteLocale } from "@/hooks/useRouteLocale";
import { usePageMeta } from "@/hooks/usePageMeta";
import { PUBLIC_ROUTES } from "@/routes/public";
import { PublicContentLayout } from "@/components/public/PublicContentLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

/** Cookie policy, linked from the consent banner and the footers; public chrome and page meta since JUB-180. */
export default function CookiesPolicyPage() {
  const { t } = useTranslation();
  const locale = useRouteLocale();

  usePageMeta({
    title: t("cookies.policy.metaTitle"),
    description: t("cookies.policy.metaDescription"),
    locale,
    path: PUBLIC_ROUTES.cookiesPolicy(locale),
    alternates: { ro: PUBLIC_ROUTES.cookiesPolicy("ro"), en: PUBLIC_ROUTES.cookiesPolicy("en") },
  });

  return (
    <PublicContentLayout>
      <Card>
        <CardHeader>
          <CardTitle className="text-3xl">
            {t("cookies.policy.title")}
          </CardTitle>
          <CardDescription>
            {t("cookies.policy.lastUpdated")}
          </CardDescription>
        </CardHeader>
        <CardContent className="prose prose-sm max-w-none dark:prose-invert">
          <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-3">
              {t("cookies.policy.whatAreCookies.title", {
              })}
            </h2>
            <p>
              {t("cookies.policy.whatAreCookies.content")}
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-3">
              {t("cookies.policy.howWeUseCookies.title")}
            </h2>
            <p className="mb-3">
              {t("cookies.policy.howWeUseCookies.intro")}
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>
                  {t("cookies.policy.essential.title")}
                </strong>{" "}
                {t("cookies.policy.essential.description")}
              </li>
              <li>
                <strong>
                  {t("cookies.policy.payment.title")}
                </strong>{" "}
                {t("cookies.policy.payment.description")}
              </li>
              <li>
                <strong>
                  {t("cookies.policy.analytics.title")}
                </strong>{" "}
                {t("cookies.policy.analytics.description")}
              </li>
              <li>
                <strong>
                  {t("cookies.policy.marketing.title")}
                </strong>{" "}
                {t("cookies.policy.marketing.description")}
              </li>
            </ul>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-3">
              {t("cookies.policy.yourRights.title")}
            </h2>
            <p>
              {t("cookies.policy.yourRights.content")}
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-3">
              {t("cookies.policy.contact.title")}
            </h2>
            <p>
              {t("cookies.policy.contact.content")}
            </p>
          </section>
        </CardContent>
      </Card>
    </PublicContentLayout>
  );
}
